import { CATEGORIES } from "./consts.js";

// Figma 6999:50834 — 上段=未選択(35) / 下段CK=選択(40)。マンションは対象外
// ※パスを文字列で書かず import するのは、本番が /bunjo 配下で配信されるため。
//   import ならビルド時に接頭辞込みのURLへ解決される（webpack.mix.js の assetPrefix）。
//   文字列だと /images/... のままになり、/bunjo の外を指してピンが表示されない
import PIN_HOME_DEFAULT from "images/search/map/pin-home-default.svg";
import PIN_HOME_ACTIVE from "images/search/map/pin-home-active.svg";
import PIN_LAND_DEFAULT from "images/search/map/pin-land-default.svg";
import PIN_LAND_ACTIVE from "images/search/map/pin-land-active.svg";

// 選択状態の切り替えはこのボタンの class だけで完結させ、ピンを作り直さない（カクつき防止）
const PIN_BUTTON_SELECTOR = ".pg-search-map-pin";
const PIN_ACTIVE_CLASS = "is-active";

const MANSION_CATEGORIES = new Set([
    CATEGORIES.NEW_MANSION,
    CATEGORIES.USED_MANSION,
]);

const HOUSE_CATEGORIES = new Set([
    CATEGORIES.HOUSE,
    CATEGORIES.NEW_HOUSE,
    CATEGORIES.USED_HOUSE,
]);

const isLandCategory = (categoryType) => categoryType === CATEGORIES.LAND;
const isMansionCategory = (categoryType) => MANSION_CATEGORIES.has(categoryType);
const isHouseCategory = (categoryType) => HOUSE_CATEGORIES.has(categoryType);

const escapeHtml = (str) =>
    String(str ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");

const pinTypeClass = (categoryType) => {
    if (isLandCategory(categoryType)) return "is-land";
    if (isMansionCategory(categoryType)) return "is-mansion";
    if (isHouseCategory(categoryType)) return "is-house";
    return "is-house";
};

// 未選択/選択の2枚を常に埋め込み、表示切替はCSS任せ（切替時の画像再取得を避ける）
const pinIconsHtml = (categoryType) => {
    const isLand = isLandCategory(categoryType);
    const def = isLand ? PIN_LAND_DEFAULT : PIN_HOME_DEFAULT;
    const act = isLand ? PIN_LAND_ACTIVE : PIN_HOME_ACTIVE;
    return `<img class="pg-search-map-pin__icon pg-search-map-pin__icon--default" src="${def}" alt="" width="22" height="22" aria-hidden="true"><img class="pg-search-map-pin__icon pg-search-map-pin__icon--active" src="${act}" alt="" width="22" height="22" aria-hidden="true">`;
};

/**
 * 地図ピン（家 / 土地）のDOMを生成する。マンションは対象外。
 * AdvancedMarkerElement の content はそのまま挿入されるため、
 * Leaflet の divIcon が付けていたラッパー（pg-search-map-pin-wrap）を自前で作る。
 * ラッパーは 35px + margin 2.5px = 40px となり、content 既定の下端中央アンカーが
 * Leaflet 時代の iconAnchor [20, 40] と一致する。
 */
export const createPinElement = (property) => {
    const isLand = isLandCategory(property.category_type);
    const cls = ["pg-search-map-pin", pinTypeClass(property.category_type)].join(" ");
    // 読み上げ用の種別名はサーバが渡す category_name をそのまま使う。
    // ConvertEstate::getCategoryName() 経由なので config('master.estate_type_label') に
    // 自動追随し、中古物件のピンが「新築戸建て」と読まれる不具合も直る（2026-08-21）。
    // 欠けたときの保険は種別を断定しない語にする（嘘のラベルを読ませない）
    const label = property.category_name || (isLand ? "土地" : "戸建て");

    const wrap = document.createElement("div");
    wrap.className = "pg-search-map-pin-wrap";
    wrap.innerHTML = `<button type="button" class="${cls}" aria-label="${escapeHtml(label)}: ${escapeHtml(property.title)}">${pinIconsHtml(property.category_type)}</button>`;

    return wrap;
};

/** 選択中ピンの見た目だけ差し替える */
export const setPinActive = (pinElement, active) => {
    pinElement
        ?.querySelector(PIN_BUTTON_SELECTOR)
        ?.classList.toggle(PIN_ACTIVE_CLASS, active);
};
